var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.color)?_c('v-alert',{attrs:{"type":"color","value":true}},[_vm._v("\n  "+_vm._s(_vm.Value)+"\n")]):_c('span',[_vm._v(" "+_vm._s(_vm.Value))])}
var staticRenderFns = []

export { render, staticRenderFns }